var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C8.44771 2 8 2.44772 8 3V3.65456C9.1577 2.92324 10.5294 2.5 12 2.5C13.4706 2.5 14.8423 2.92324 16 3.65456V3C16 2.44772 15.5523 2 15 2H9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.3454C9.1577 17.0768 10.5294 17.5 12 17.5C13.4706 17.5 14.8423 17.0768 16 16.3454V21.5C16 21.912 15.5296 22.1472 15.2 21.9L12.6 19.95C12.2444 19.6833 11.7556 19.6833 11.4 19.95L8.8 21.9C8.47038 22.1472 8 21.912 8 21.5V16.3454Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM13.2068 8.33167C13.2574 8.45209 13.366 8.53468 13.4911 8.54782L15.6859 8.77848C15.9876 8.81019 16.1094 9.20235 15.883 9.41369L14.2369 10.9507C14.1431 11.0382 14.1017 11.1719 14.1284 11.3004L14.597 13.5567C14.6615 13.8669 14.3428 14.1093 14.0808 13.9492L12.1757 12.7855C12.1214 12.7523 12.0607 12.7357 12 12.7357C11.9393 12.7357 11.8786 12.7523 11.8243 12.7855L9.91919 13.9492C9.65723 14.1093 9.33854 13.8669 9.40299 13.5567L9.87165 11.3004C9.89835 11.1719 9.85687 11.0382 9.76308 10.9507L8.11697 9.41369C7.89063 9.20235 8.01236 8.81019 8.31415 8.77848L10.5089 8.54782C10.634 8.53468 10.7426 8.45209 10.7932 8.33167L11.681 6.21798C11.803 5.92734 12.197 5.92734 12.319 6.21798L13.2068 8.33167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.2afddef902fdac4ca4b60554d04409a6.svg";
export { ForwardRef as ReactComponent };